import { useParams } from "react-router-dom";
import "./checkout.css";
import moneyback from "../media/money-back.jpg";
import { CLIENT_ID } from "../Config/config";
import React, { useState, useEffect } from "react";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import Footer from "../Home/footer";
import Header from "../Home/header";
import { Helmet } from "react-helmet-async";
const Checkout = () => {

  const iframLink = process.env.REACT_APP_IFRAM;
  const { id } = useParams();

  const [price, setprice] = useState();
  const [month, setmonth] = useState();
  const [link, setlink] = useState();
  const [email, setemail] = useState();
  const [phone, setphone] = useState();
  const [name, setname] = useState();
  const [contry, setcontry] = useState();
  useEffect(() => {
    if (id === "1") {
      setprice(12.99);
      setmonth(1);
      
      setlink(`${iframLink}/1/${email}/${name}/${contry}/${phone}`)
    }
    if (id === "2") {
      setprice(23.99);
      setmonth(3);
      setlink(`${iframLink}/2/${email}/${name}/${contry}/${phone}}`)
    }
    if (id === "3") {
      setprice(34.99);
      setmonth(6);
      setlink(`${iframLink}/3/${email}/${name}/${contry}/${phone}}`)
    }
    if (id === "4") {
      setprice(57.99);
      setmonth(12);
      setlink(`${iframLink}/4/${email}/${name}/${contry}/${phone}}`)
    }
  }, [email ,name , contry]);

  const submit = () => {};

  const [show, setShow] = useState(false);
  const [success, setSuccess] = useState(false);
  const [ErrorMessage, setErrorMessage] = useState("");
  const [orderID, setOrderID] = useState(false);



 
  // creates a paypal order
  const createOrder = (data, actions) => {
    return actions.order
      .create({
        purchase_units: [
          {
            description: "create a modern luxury logo design for your business",
            amount: {
              currency_code: "USD",
              value: price,
            },
          },
        ],
      })
      .then((orderID) => {
        setOrderID(orderID);
        return orderID;
      });
  };

  // check Approval
  const onApprove = (data, actions) => {
    return actions.order.capture().then(function (details) {
      const { payer } = details;
      setSuccess(true);
    });
  };

  const onError = (data, actions) => {
    setErrorMessage("An Error occured with your payment ");
  };
  var raw = JSON.stringify({
    id_user: 1,
    email: email,
    fullname: name,
    phone: phone,
    contry: contry,
    price: price,
    month: month,
  });

  const host = process.env.REACT_APP_HOST;
  console.log(host);
  useEffect(() => {
    localStorage.setItem("email", email);
  }, [email]);

  useEffect(() => {
    if (success) {
      console.log("Order successful . Your order id is--", orderID);

      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(`${host}/NewPurchase`, requestOptions)
        .then((response) => response.text())
        .then((result) => console.log(result))
        .catch((error) => console.log("error", error));

      window.location.href = "/Thankyou";
    }
  }, [success]);


  
  return (
    <>
    
    <Helmet>
        <title>
          Best IPTV Subscription Service Provider at 9.99$ - IPTVshop
        </title>
        <meta
          name="description"
          content="Fast order delivery, Weekly updated, Fast zapping, Premium Quality. Support 7 Days A Week. Premium 4k Channels from more than 82 Countries. Fast Deliver once your Place order. Watch on All Devices. Safe & Secure payments. No More Expensive Cable."
        />
        <link rel="canonical" href="/Checkout" />
    </Helmet>
    
      <Header />

      <div>  

      <div className="etapsdiv">
        <div className="firststep">
          <div className="iconstep">
            <i class="fa-solid fa-cart-shopping"></i>
          </div>
          <div className="borderspan"> </div>
        </div>
        <div className="firststep">
          <div className="iconstep">
            <i style={{ color: "black" }} class="fa-solid fa-cash-register"></i>
          </div>
          <div className="borderspan">
            <span> </span>
          </div>
        </div>
        <div className="firststep">
          <div className="iconstep">
            <i class="fas fa-check-circle"></i>
          </div>
        </div>
      </div>

      <div className="allinfodiv">
        <div  style={{textAlign:'center'}} >
          <div className="contactinfo">
            <div className="parainfo">
              <h4>
                {" "}
                {month} MONTH IPTV SUBSCRIPTION” has been added to your cart.
              </h4>
            </div>
            <div className="parainfo">
              <h3>Contact Information</h3>
            </div>
            <div>   

            <div className="inputdiv">
              <input
                value={name}
                onChange={(e) => {
                  setname(e.target.value);
                }}
                required
                type="text"
                placeholder="Full Name *"
                className="infoinput"
              />
            </div>
            <div className="inputdiv">
              <input
                value={email}
                onChange={(e) => {
                  setemail(e.target.value);
                }}
                required
                type="email"
                placeholder="Email address *"
                className="infoinput"
              />
            </div>
            <div className="inputdiv">
              <input
                value={phone}
                onChange={(e) => {
                  setphone(e.target.value);
                }}
                required
                type="tel"
                placeholder="phone *"
                className="infoinput"
              />
            </div>
            <div className="inputdiv">
              <select
                value={contry}
                onChange={(e) => {
                  setcontry(e.target.value);
                }}
                required
                className="form-select"
                id="country"
                name="country"
              >
                <option>select country</option>
                <option value="AF">Afghanistan</option>
                <option value="AX">Aland Islands</option>
                <option value="AL">Albania</option>
                <option value="DZ">Algeria</option>
                <option value="AS">American Samoa</option>
                <option value="AD">Andorra</option>
                <option value="AO">Angola</option>
                <option value="AI">Anguilla</option>
                <option value="AQ">Antarctica</option>
                <option value="AG">Antigua and Barbuda</option>
                <option value="AR">Argentina</option>
                <option value="AM">Armenia</option>
                <option value="AW">Aruba</option>
                <option value="AU">Australia</option>
                <option value="AT">Austria</option>
                <option value="AZ">Azerbaijan</option>
                <option value="BS">Bahamas</option>
                <option value="BH">Bahrain</option>
                <option value="BD">Bangladesh</option>
                <option value="BB">Barbados</option>
                <option value="BY">Belarus</option>
                <option value="BE">Belgium</option>
                <option value="BZ">Belize</option>
                <option value="BJ">Benin</option>
                <option value="BM">Bermuda</option>
                <option value="BT">Bhutan</option>
                <option value="BO">Bolivia</option>
                <option value="BQ">Bonaire, Sint Eustatius and Saba</option>
                <option value="BA">Bosnia and Herzegovina</option>
                <option value="BW">Botswana</option>
                <option value="BV">Bouvet Island</option>
                <option value="BR">Brazil</option>
                <option value="IO">British Indian Ocean Territory</option>
                <option value="BN">Brunei Darussalam</option>
                <option value="BG">Bulgaria</option>
                <option value="BF">Burkina Faso</option>
                <option value="BI">Burundi</option>
                <option value="KH">Cambodia</option>
                <option value="CM">Cameroon</option>
                <option value="CA">Canada</option>
                <option value="CV">Cape Verde</option>
                <option value="KY">Cayman Islands</option>
                <option value="CF">Central African Republic</option>
                <option value="TD">Chad</option>
                <option value="CL">Chile</option>
                <option value="CN">China</option>
                <option value="CX">Christmas Island</option>
                <option value="CC">Cocos (Keeling) Islands</option>
                <option value="CO">Colombia</option>
                <option value="KM">Comoros</option>
                <option value="CG">Congo</option>
                <option value="CD">
                  Congo, Democratic Republic of the Congo
                </option>
                <option value="CK">Cook Islands</option>
                <option value="CR">Costa Rica</option>
                <option value="CI">Cote D'Ivoire</option>
                <option value="HR">Croatia</option>
                <option value="CU">Cuba</option>
                <option value="CW">Curacao</option>
                <option value="CY">Cyprus</option>
                <option value="CZ">Czech Republic</option>
                <option value="DK">Denmark</option>
                <option value="DJ">Djibouti</option>
                <option value="DM">Dominica</option>
                <option value="DO">Dominican Republic</option>
                <option value="EC">Ecuador</option>
                <option value="EG">Egypt</option>
                <option value="SV">El Salvador</option>
                <option value="GQ">Equatorial Guinea</option>
                <option value="ER">Eritrea</option>
                <option value="EE">Estonia</option>
                <option value="ET">Ethiopia</option>
                <option value="FK">Falkland Islands (Malvinas)</option>
                <option value="FO">Faroe Islands</option>
                <option value="FJ">Fiji</option>
                <option value="FI">Finland</option>
                <option value="FR">France</option>
                <option value="GF">French Guiana</option>
                <option value="PF">French Polynesia</option>
                <option value="TF">French Southern Territories</option>
                <option value="GA">Gabon</option>
                <option value="GM">Gambia</option>
                <option value="GE">Georgia</option>
                <option value="DE">Germany</option>
                <option value="GH">Ghana</option>
                <option value="GI">Gibraltar</option>
                <option value="GR">Greece</option>
                <option value="GL">Greenland</option>
                <option value="GD">Grenada</option>
                <option value="GP">Guadeloupe</option>
                <option value="GU">Guam</option>
                <option value="GT">Guatemala</option>
                <option value="GG">Guernsey</option>
                <option value="GN">Guinea</option>
                <option value="GW">Guinea-Bissau</option>
                <option value="GY">Guyana</option>
                <option value="HT">Haiti</option>
                <option value="HM">Heard Island and Mcdonald Islands</option>
                <option value="VA">Holy See (Vatican City State)</option>
                <option value="HN">Honduras</option>
                <option value="HK">Hong Kong</option>
                <option value="HU">Hungary</option>
                <option value="IS">Iceland</option>
                <option value="IN">India</option>
                <option value="ID">Indonesia</option>
                <option value="IR">Iran, Islamic Republic of</option>
                <option value="IQ">Iraq</option>
                <option value="IE">Ireland</option>
                <option value="IM">Isle of Man</option>
                <option value="IL">Israel</option>
                <option value="IT">Italy</option>
                <option value="JM">Jamaica</option>
                <option value="JP">Japan</option>
                <option value="JE">Jersey</option>
                <option value="JO">Jordan</option>
                <option value="KZ">Kazakhstan</option>
                <option value="KE">Kenya</option>
                <option value="KI">Kiribati</option>
                <option value="KP">
                  Korea, Democratic People's Republic of
                </option>
                <option value="KR">Korea, Republic of</option>
                <option value="XK">Kosovo</option>
                <option value="KW">Kuwait</option>
                <option value="KG">Kyrgyzstan</option>
                <option value="LA">Lao People's Democratic Republic</option>
                <option value="LV">Latvia</option>
                <option value="LB">Lebanon</option>
                <option value="LS">Lesotho</option>
                <option value="LR">Liberia</option>
                <option value="LY">Libyan Arab Jamahiriya</option>
                <option value="LI">Liechtenstein</option>
                <option value="LT">Lithuania</option>
                <option value="LU">Luxembourg</option>
                <option value="MO">Macao</option>
                <option value="MK">
                  Macedonia, the Former Yugoslav Republic of
                </option>
                <option value="MG">Madagascar</option>
                <option value="MW">Malawi</option>
                <option value="MY">Malaysia</option>
                <option value="MV">Maldives</option>
                <option value="ML">Mali</option>
                <option value="MT">Malta</option>
                <option value="MH">Marshall Islands</option>
                <option value="MQ">Martinique</option>
                <option value="MR">Mauritania</option>
                <option value="MU">Mauritius</option>
                <option value="YT">Mayotte</option>
                <option value="MX">Mexico</option>
                <option value="FM">Micronesia, Federated States of</option>
                <option value="MD">Moldova, Republic of</option>
                <option value="MC">Monaco</option>
                <option value="MN">Mongolia</option>
                <option value="ME">Montenegro</option>
                <option value="MS">Montserrat</option>
                <option value="MA">Morocco</option>
                <option value="MZ">Mozambique</option>
                <option value="MM">Myanmar</option>
                <option value="NA">Namibia</option>
                <option value="NR">Nauru</option>
                <option value="NP">Nepal</option>
                <option value="NL">Netherlands</option>
                <option value="AN">Netherlands Antilles</option>
                <option value="NC">New Caledonia</option>
                <option value="NZ">New Zealand</option>
                <option value="NI">Nicaragua</option>
                <option value="NE">Niger</option>
                <option value="NG">Nigeria</option>
                <option value="NU">Niue</option>
                <option value="NF">Norfolk Island</option>
                <option value="MP">Northern Mariana Islands</option>
                <option value="NO">Norway</option>
                <option value="OM">Oman</option>
                <option value="PK">Pakistan</option>
                <option value="PW">Palau</option>
                <option value="PS">Palestinian Territory, Occupied</option>
                <option value="PA">Panama</option>
                <option value="PG">Papua New Guinea</option>
                <option value="PY">Paraguay</option>
                <option value="PE">Peru</option>
                <option value="PH">Philippines</option>
                <option value="PN">Pitcairn</option>
                <option value="PL">Poland</option>
                <option value="PT">Portugal</option>
                <option value="PR">Puerto Rico</option>
                <option value="QA">Qatar</option>
                <option value="RE">Reunion</option>
                <option value="RO">Romania</option>
                <option value="RU">Russian Federation</option>
                <option value="RW">Rwanda</option>
                <option value="BL">Saint Barthelemy</option>
                <option value="SH">Saint Helena</option>
                <option value="KN">Saint Kitts and Nevis</option>
                <option value="LC">Saint Lucia</option>
                <option value="MF">Saint Martin</option>
                <option value="PM">Saint Pierre and Miquelon</option>
                <option value="VC">Saint Vincent and the Grenadines</option>
                <option value="WS">Samoa</option>
                <option value="SM">San Marino</option>
                <option value="ST">Sao Tome and Principe</option>
                <option value="SA">Saudi Arabia</option>
                <option value="SN">Senegal</option>
                <option value="RS">Serbia</option>
                <option value="CS">Serbia and Montenegro</option>
                <option value="SC">Seychelles</option>
                <option value="SL">Sierra Leone</option>
                <option value="SG">Singapore</option>
                <option value="SX">Sint Maarten</option>
                <option value="SK">Slovakia</option>
                <option value="SI">Slovenia</option>
                <option value="SB">Solomon Islands</option>
                <option value="SO">Somalia</option>
                <option value="ZA">South Africa</option>
                <option value="GS">
                  South Georgia and the South Sandwich Islands
                </option>
                <option value="SS">South Sudan</option>
                <option value="ES">Spain</option>
                <option value="LK">Sri Lanka</option>
                <option value="SD">Sudan</option>
                <option value="SR">Suriname</option>
                <option value="SJ">Svalbard and Jan Mayen</option>
                <option value="SZ">Swaziland</option>
                <option value="SE">Sweden</option>
                <option value="CH">Switzerland</option>
                <option value="SY">Syrian Arab Republic</option>
                <option value="TW">Taiwan, Province of China</option>
                <option value="TJ">Tajikistan</option>
                <option value="TZ">Tanzania, United Republic of</option>
                <option value="TH">Thailand</option>
                <option value="TL">Timor-Leste</option>
                <option value="TG">Togo</option>
                <option value="TK">Tokelau</option>
                <option value="TO">Tonga</option>
                <option value="TT">Trinidad and Tobago</option>
                <option value="TN">Tunisia</option>
                <option value="TR">Turkey</option>
                <option value="TM">Turkmenistan</option>
                <option value="TC">Turks and Caicos Islands</option>
                <option value="TV">Tuvalu</option>
                <option value="UG">Uganda</option>
                <option value="UA">Ukraine</option>
                <option value="AE">United Arab Emirates</option>
                <option value="GB">United Kingdom</option>
                <option value="US">United States</option>
                <option value="UM">United States Minor Outlying Islands</option>
                <option value="UY">Uruguay</option>
                <option value="UZ">Uzbekistan</option>
                <option value="VU">Vanuatu</option>
                <option value="VE">Venezuela</option>
                <option value="VN">Viet Nam</option>
                <option value="VG">Virgin Islands, British</option>
                <option value="VI">Virgin Islands, U.s.</option>
                <option value="WF">Wallis and Futuna</option>
                <option value="EH">Western Sahara</option>
                <option value="YE">Yemen</option>
                <option value="ZM">Zambia</option>
                <option value="ZW">Zimbabwe</option>
              </select>
            </div>
            </div>
          </div>

          <div className="allorderdiv">
            <div className="orderdiv">
              <div className="Subtotal">
                <div className="prod">
                  <p className="mypara"> Product</p>
                </div>
              </div>
              <div className="Subtotal">
                <div className="MONTH">
                  <p className="mypara">{month} MONTH IPTV</p>
                </div>
              </div>

              <div className="Subtotal">
                <div className="prod">
                  <p className="mypara"> Fees</p>
                </div>
              </div>

              <div style={{ borderBottom: "none" }} className="Subtotal">
                <div className="prod">
                  <p className="totalword"> Total</p>
                </div>
              </div>
            </div>

            <div className="orderdivtow">
              <div className="Subtotal">
                <div className="prod">
                  <p className="mypara"> Subtotal</p>
                </div>
              </div>
              <div className="Subtotal">
                <div className="prod">
                  <p className="mypara"> × 1</p>
                </div>
              </div>

              <div className="Subtotal">
                <div className="prod">
                  <p className="mypara"> 2%</p>
                </div>
              </div>

              <div style={{ borderBottom: "none" }} className="Subtotal">
                <div className="prod">
                  <p className="totalword"> ${price}</p>
                </div>
              </div>
            </div>
          </div>

  
          <iframe  src={link}> </iframe>
{/* 
          <PayPalScriptProvider options={{ "client-id": CLIENT_ID }}>
            <div className="paypaldiv">
              <div className="titlepay">
                <h2>Payment</h2>
              </div>
              <PayPalButtons
                style={{ layout: "vertical", borderRadius: "15px" }}
                createOrder={createOrder}
                onApprove={onApprove}
              />
            </div>
          </PayPalScriptProvider> */}
        </div>

        <div className="infodivcontent">
          <div className="title">
            <h2> What you’ll get :</h2>
          </div>
          <div className="package">
            <p>
              Entertainment package with our IPTV subscription offering a
              staggering 18,000+ channels and 85,000+ movies and series, all
              delivered seamlessly through the most reliable and stable server
              from the best IPTV provider.
            </p>
          </div>

          <div className="listol">
            <ul style={{ listStyle: "disc" }}>
              <li> 4K, FHD & HD Channels </li>
              <li>All International Channels </li>
              <li>All International Channels </li>
              <li>All Devices Supported TV, Smartphone, Laptot, Tablet </li>
              <li>100% compatible with ANDROID - IOS </li>
              <li>Fast Delivery 2min at 10min maximum </li>
              <li>Team support 24/7 to satisfy our clients </li>
              <li>News channels (e.g. CNN, BBC, Fox News, Al Jazeera) </li>
              <li>
                Sports channels (e.g. ESPN, Sky Sports, Bein Sports, Eurosport)
              </li>
              <li>
                Entertainment channels (e.g. HBO, AMC, TNT, Comedy Central)
              </li>
              <li>Movie channels (e.g. Netflix, Hulu, Amazon Prime Video) </li>
              <li>
                Kids channels (e.g. Disney Channel, Cartoon Network,
                Nickelodeon)
              </li>
              <li>Music channels (e.g. MTV, VH1, iHeartRadio) </li>
              <li>
                International channels (e.g. Univision, Telemundo, Rai Italia,
                Zee TV)
              </li>
              <li>
                Documentary channels (e.g. Discovery Channel, National
                Geographic, History)
              </li>
              <li>
                Lifestyle channels (e.g. Food Network, HGTV, Travel Channel)
              </li>
            </ul>
          </div>

          <div className="reviews">
            <div className="titlerev">
              <h3>Customer reviews</h3>
            </div>
            <div className="boxrev">
              <div className="revmsg">
                <p>
                  “Amazing seller, Premium IPTV Service and provide arabic iptv
                  channels and all documentary and sport iptv channels. Thank
                  you.”
                </p>
              </div>
              <div className="picdiv">
                <div className="picrev">
                  <img style={{width:"55px"}} src="https://i.pinimg.com/280x280_RS/dc/04/b7/dc04b7f7d90d632a1aa8e5f9593c88af.jpg" />
                </div>
                <div className="namerev">
                  <div> Kristina E. Allen</div>
                  <div className="usa">
                    <span> Chicago, USA </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="reviews">
            <div className="boxrev">
              <div className="revmsg">
                <p>
                  “I can confirm you that the stream is really awesome and
                  stable. I'm very happy to watch all my favorite channels.”
                </p>
              </div>
              <div className="picdiv">
                <div className="picrev">
                  <img style={{width:"55px"}} src="https://assets-global.website-files.com/5fba23eb8789c3c7fcfb5f31/622fa2005a5fabed64659616_607d8ea5221240c8618ea3d1_Kirk-Du-Plessis-Avatar%20(1).png" />
                </div>
                <div className="namerev">
                  <div> Frank N. Woodys</div>
                  <div className="usa">
                    <span> Concord, CA 94520 </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="reviews">
            <div className="titlerev">
              <h1>Purchase with confidence</h1>
            </div>
            <div className="boxrev">
              <div className="picdiv">
                <div className="picmoney">
                  <img src={moneyback} />
                </div>
                <div className="backmsg">
                  <div className="back">100% money back guarantee!</div>
                  <div style={{ textAlign: "center" }} className="back">
                    <span> 100% money back guarantee! </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
      <Footer />
    </>
  );
};

export default Checkout;
